import { __awaiter, __generator } from "tslib";
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { localeParam } from '../models/Constants';
import { postRequest } from './postRequest';
export function upsertSetting(apiOptions) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, postRequest(apiOptions.upsertApiPath, apiOptions.setting, KnownInstrumentationEvents.EdgeworthUpsertSettingRequest, "EdgeworthUpsertSetting" /* KnownRequestInstrumentationEvents.EdgeworthUpsertSettingRequest */, apiOptions, "".concat(localeParam).concat(apiOptions.preferredCulture))];
        });
    });
}
//# sourceMappingURL=upsertSetting.js.map